<template>
    <div class="ml-2 hc">
      <span v-if="debug === 'true' || debug === true">{{version}}</span>
        <p class="text-left" style="color: var(--color-dentalia-v2); font-weight: bold;">Multiples tratamientos a múltiples padecimientos</p>
        <div align="right">
            <b-button
                v-b-tooltip.hover title="Agregar grupo"
                variant="link"
                @click="crearGrupo()">
                <font-awesome-icon icon="plus-circle"/>
            </b-button>
        </div>
        <b-row>
            <b-col align="left" cols="4">
                <b-card style="border-radius: 30px;">
                    <p style="color: var(--color-dentalia-v2); font-weight: 500;">
                        Padecimientos existentes
                    </p>
                        <div class="barras d-flex mt-3"
                            :style="formularioPadecimientos != undefined && formularioPadecimientos != null ? 'margin-left:0px; margin-right:0px;':''">
                            <b-form-input class="input-filter" v-model="palabraClaveBusqueda" placeholder="Búsqueda de padecimientos" type="text"
                                        @keydown.enter.prevent="buscarPadecimiento()">
                            </b-form-input>
                            <b-button class="btn-extra-small" variant="info" @click="buscarPadecimiento()">
                                <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;"></em></span>
                            </b-button>
                        </div>
                    <div class="mt-4 pr-4 scrollable-container-mult-tx no-horizontal-scroll" style="height: 50vh;">
                        <div v-for="(padecimiento,index) in resultadosBusquedaFiltro" :key="padecimiento + index">
                        <b-row style="padding: 0px;">
                            <b-col cols="1">
                                <em v-if="padecimiento.visiblePadecimiento" class="chevron_gris ml-2" style="width: 13px; transform: rotate(180deg);" @click="padecimiento.visiblePadecimiento = false"></em>
                                <em v-else class="chevron_gris chevron-verde ml-2" style="width: 13px; transform: rotate(360deg);" @click="padecimiento.visiblePadecimiento = true"></em>
                            </b-col>
                            <b-col>
                                <p v-if="!padecimiento.seleccionado" class="ml-2">{{ padecimiento.nombrePadecimiento }}</p>
                                <p v-else-if="padecimiento.seleccionado" v-b-tooltip.hover.top title="Este padecimiento ya está agregado a un grupo" :style="padecimiento.nombrePadecimiento ? 'color: #C6C6C6' : ''" class="ml-2">{{ padecimiento.nombrePadecimiento }}</p>
                            </b-col>
                            <b-col cols="1">
                                <div v-if="grupoVisible && !padecimiento.seleccionado">
                                    <b-button size="sm" variant="link" @click="agregarPadecimiento(padecimiento)">
                                        <font-awesome-icon :icon="['fas', 'chevron-circle-right']"/>
                                    </b-button>
                                </div>
                               
                            </b-col>
                        </b-row>
                        <div class="mb-3">
                            <b-collapse :visible="padecimiento.visiblePadecimiento" :id="'collapse-'+index" class="mb-2">
                            <div v-for="(p,i) in padecimiento.dientes" :key="p + i + index">
                                <div class="d-flex justify-content-between ml-4">
                                    <div class="d-flex" style="height: 1.5em;">
                                        <em class="diente_solid" style="width: 1em;"></em>
                                        <p v-if="!p.diente.seleccionado" class="ml-2">OD {{ p.diente.diente }}</p>
                                        <p v-else-if="p.diente.seleccionado" v-b-tooltip.hover.top title="Este OD ya está agregado a un grupo" :style="p.diente.seleccionado ? 'color: #C6C6C6' : ''" class="ml-2">OD {{ p.diente.diente }}</p>
                                    </div>
                                    <div>
                                        <b-button v-if="!p.diente.seleccionado && grupoVisible" size="sm" variant="link" @click="agregarOD({p: p, i: i, padecimiento: padecimiento})">
                                            <font-awesome-icon :icon="['fas', 'chevron-circle-right']"/>
                                        </b-button>
                                    </div>
                                </div>
                               
                            </div>
                        </b-collapse>
                        </div>
                    </div>
                    </div>
                </b-card>
            </b-col>
            <b-col>
                <div style="height: 68vh;">
                    <div v-if="grupos.length == 0" class="d-flex justify-content-center align-items-center" style="height: 32em;">
                        <span>Sin grupos creados</span>
                    </div>
                    <div v-else class="scrollable-container-mult-tx2 no-horizontal-scroll">
                        <div v-for="(grupo,index) in grupos" :key="grupo + index" class="" style="border-radius: 15px; border: 1px solid #E0E0E0;  padding-right: 0px">
                            <div class="row w-100 d-flex align-items-center" style="min-height: 70px; margin-right: 0px;">
                                <div class="col d-flex justify-content-center align-items-center" style="border-right: 1px solid #E6E6E6;">
                                    <em class="diente_outline" style="width: 1.2em;"></em>
                                    <p class="mt-3 ml-3" style="color: var(--color-dentalia-v2); font-weight: bold;">Múltiples tratamientos</p>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center" style="border-right: 1px solid #E6E6E6; height: 70px;">
                                    <p class="mt-3">{{ grupo.numOds }} ODs seleccionados</p>
                                </div>
                                <div class="col d-flex justify-content-center align-items-center">
                                    <p class="mt-3">{{ grupo.tratamientos.length }} Tratamientos agregados</p>

                                    <div >
                                        <b-button v-if="grupo.visible" class="mostrar" size="sm" variant="link" @click="mostrarGrupo(grupo)" >
                                        <font-awesome-icon :icon="['fas', 'chevron-circle-up']"/>
                                    </b-button>
                                    <b-button v-if=" !grupo.visible" class="esconder" size="sm" variant="link" @click="esconderGrupo(index)">
                                        <font-awesome-icon :icon="['fas', 'chevron-circle-down']"/>
                                    </b-button>
                                    <b-button size="sm" v-b-tooltip.hover.top title="Eliminar Grupo" style="color: red !important;" variant="link" @click="eliminarGrupo(index)">
                                        <font-awesome-icon icon="times-circle"/>
                                    </b-button>
                                    </div>
                                </div>
                            </div>
                           
                            <b-collapse :visible="grupo.visible" :id="'collapse-'+index" class="mt-2 ml-3">
                                <div style="font-weight: 550; font-size: .8em;">
                                    <p style="color: #F49058;">Esta funcionalidad sólo está disponible para la opción 1 del PTI</p>
                                    <p style="color: #F49058;">Se sobreescribirán los tratamientos previamente agregados a los siguientes órganos dentales</p>
                                </div>
                                
                                <div class="text-left">
                                    <p style="font-weight: 550;">Órganos dentales seleccionados:</p>
                                    <div v-if="grupo.padecimientos.length > 0">
                                        <div v-for="(padecimientosG,indexP) in grupo.padecimientos" :key="padecimientosG + indexP" class="mt-2 d-flex">
                                            <div class="d-flex">
                                                <div class="d-flex justify-content-center align-items-center" style="height: 2em;">
                                                    <b-button size="sm" v-b-tooltip.hover title="Eliminar padecimiento"
                                                        style="color: red !important;" variant="link"
                                                        @click="eliminarPadecimiento({grupos: grupo.padecimientos, indexP: indexP, padecimientosG: padecimientosG, grupo: grupo})">
                                                        <font-awesome-icon icon="times-circle"/>
                                                    </b-button>
                                                    <p class="ml-2 mt-3">{{ padecimientosG.padecimiento.descripcion }}</p>
                                                </div>
                                                <div class="ml-5 d-flex">
                                                    <div no-body style="min-width: 100px;" v-for="(diente,indexD) in padecimientosG.dientes" :key="diente+indexD+indexP" class="" >
                                                        <div class="d-flex">
                                                            <div class="d-flex align-items-center justify-content-center ml-3" style="height: 2em; border: 1px solid #B9E7EE; min-width: 7em; border-radius: 30px;">
                                                                <p class="mt-3" style="color: #3DA0B0;">{{ diente.diente }}</p>
                                                            </div>
                                                            <div>
                                                                <b-button size="sm" v-b-tooltip.hover title="Eliminar diente"
                                                                        style="color: red !important;" variant="link"
                                                                        @click="eliminarDiente({padecimientos: grupo.padecimientos, indexP: indexP, dientes: padecimientosG.dientes, indexD: indexD, diente: diente, grupo: grupo})">
                                                                        <font-awesome-icon icon="times-circle"/>
                                                                    </b-button>
                                                            </div>
                                                        </div>
                                                    </div>
                                            </div>
                                            </div>
                                           
                                            
                                        </div>
                                    </div>

                                    <div v-else style="min-height: 60px;">
                                        <p>Sin órganos dentales seleccionados</p>
                                    </div>
                                </div>
                                
                                <div class="text-left mt-4">
                                    <p style="font-weight: 550;">Tratamientos para los OD's:</p>

                                    <b-row class="text-center">
                                        <b-col>
                                            <label>Tratamiento</label>
                                        </b-col>
                                        <b-col cols="2">
                                            <label>Cantidad</label>
                                        </b-col>
                                        <b-col cols="1">
                                            <b-button
                                                    v-b-tooltip.hover title="Agregar Tratamiento"
                                                    variant="link"
                                                    @click="agregarTratamiento(grupo)">
                                                <font-awesome-icon icon="plus-circle"/>
                                            </b-button>
                                        </b-col>
                                    </b-row>
                                    <div v-if=" grupo.tratamientos.length > 0">
                                        <div class="mb-2" v-for="(item, i) in grupo.tratamientos" :key="'tratamiento'+i">
                                            <b-row align="center">
                                                <b-col class="pr-0">
                                                    <SelectTratamientos
                                                        :indexOpcion="0"
                                                        :catalogoTratamientos="catTratamientos"
                                                        :tratamiento="item"
                                                        :tratamientos="grupo.tratamientos"
                                                        :i="i"
                                                    ></SelectTratamientos>
                                                </b-col>
                                                <b-col cols="2" class="mt-2 p-0 ">
                                                    <b-input style="width: 60%" min="1"
                                                        type="number" v-model="item.cantidad">
                                                    </b-input>
                                                </b-col>
                                                <b-col cols="1" class="p-0 mt-2">
                                                    <b-button size="sm" v-b-tooltip.hover title="Eliminar Tratamiento"
                                                        style="color: red !important;" variant="link"
                                                        @click="eliminarTratamiento({grupo: grupo.tratamientos , item: item})">
                                                        <font-awesome-icon icon="times-circle"/>
                                                    </b-button>
                                                </b-col>
                                            </b-row>
                                        </div>
                                    </div>
                                    <div v-else class="d-flex justify-content-center align-items-center" style="min-height: 100px;">
                                        <p>Sin tratamientos agregados</p>
                                    </div>
                                </div>
                                
                            </b-collapse>
                        </div>
                    </div>
                </div>
            </b-col>
        </b-row>
        <b-row class="m-2">
            <b-col align="right">
                <b-button variant="outline-primary" pill @click="guardarMultiplesTrts()">
                    guardar
                </b-button>
            </b-col>
            <b-col cols="2"></b-col>
            <b-col align="left">
                <b-button variant="outline-secondary" @click="cancelar()" pill>
                    cancelar
                </b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import SelectTratamientos from "./SelectTratamientos.vue";
export default {
    name: "MultiplesTratamientos",
    components: {
        SelectTratamientos,
    },
    data() {
        return{
          version: process.env.VUE_APP_ENV_VERSION,
          debug: false,
            grupos: [],
            grupoVisible: false,
            palabraClaveBusqueda: '',
            resultadosBusquedaFiltro: [],
        }
    },
    props:{
        multiplesTrts: Boolean,
        formularioPadecimientos: Array,
        catTratamientos: null,
    },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
    mounted() {
        this.resultadosBusquedaFiltro = this.formularioPadecimientos
    },
    methods:{
        crearGrupo(){
            this.grupos.push({visible: false, numOds: 0, padecimientos: [], tratamientos: []})
        },

        buscarPadecimiento() {
            this.resultadosBusquedaFiltro = this.buscarHijos(this.formularioPadecimientos)
        },

        buscarHijos(padecimiento) {
            return padecimiento.filter(p => {
                if (p.nombrePadecimiento.toLowerCase().includes(this.palabraClaveBusqueda.toLowerCase().trim())){
                    return true;
                }
            })
        },

        guardarMultiplesTrts(){
            this.formularioPadecimientos.forEach(padecimiento => {
                padecimiento.seleccionado = false;
                padecimiento.dientes.forEach(diente => {
                    diente.diente.seleccionado = false
                });
            });
            this.$emit('guardarMultiplesTrts',this.grupos)
        },

        cancelar() {
            this.formularioPadecimientos.forEach(padecimiento => {
                padecimiento.seleccionado = false;
                padecimiento.dientes.forEach(diente => {
                    diente.diente.seleccionado = false
                });
            });
            this.$emit('cancelar')
        },

        mostrarGrupo(grupo){
            grupo.visible = false

            let gruposVisibles = this.grupos.filter(item => {
                return item.visible === true;
            })

            if(gruposVisibles.length > 0){
                this.grupoVisible = true;
            }else{
                this.grupoVisible = false;
            }
        },

        esconderGrupo(index){
            this.grupos.forEach((grupo,i) => {
                if(i == index){
                    grupo.visible = true
                    this.grupoVisible = true;
                }else{
                    grupo.visible = false
                }
            });
        },

        eliminarGrupo(index){
            //se habilita poder selececcionar el diente otra vez
            this.formularioPadecimientos.forEach(padecimiento => {
                padecimiento.dientes.forEach(diente => {
                    this.grupos[index].padecimientos.forEach(pad => {
                        if(pad.dientes.includes(diente.diente)){
                            diente.diente.seleccionado = false;
                            padecimiento.seleccionado = false;
                        }
                    });
                });
            });
            this.grupos.splice(index,1);
            this.grupoVisible = false;
        },

        agregarPadecimiento(item){
            this.grupos.forEach(grupo => {
                if(grupo.visible){
                    let idsPadecimientos = [];
                    if(grupo.padecimientos.length > 0){
                        idsPadecimientos = grupo.padecimientos.map(p => p.padecimiento.idPadecimiento);
                    }
                    //si el padecimiento ya existe solo agregamos los dientes
                    if(idsPadecimientos.includes(item.dientes[0].padecimiento.idPadecimiento)){
                        grupo.padecimientos.forEach(p => {
                            if(p.padecimiento.idPadecimiento == item.dientes[0].padecimiento.idPadecimiento){
                                item.dientes.forEach(diente => {
                                    if(diente.diente.seleccionado !== true){
                                        p.dientes.push(diente.diente);
                                        diente.diente.seleccionado = true;
                                        grupo.numOds++;
                                    }
                                });
                            }
                        });
                    }else{
                        //no existe padecimiento, lo agregamos con los dientes
                        let dientes = [];
                        item.dientes.forEach(diente => {
                            if(diente.diente.seleccionado !== true){
                                dientes.push(diente.diente);
                                diente.diente.seleccionado = true;
                                grupo.numOds++;
                            }
                        });
                        grupo.padecimientos.push({dientes: dientes, padecimiento: item.dientes[0].padecimiento})
                    }
                    item.seleccionado = true;
                }
            });
        },

        agregarOD(item){
            //se agrega el diente donde este abierta la tarjeta
            this.grupos.forEach(grupo => {
                if(grupo.visible){
                    let idsPadecimientos = [];
                    if(grupo.padecimientos.length > 0){
                        idsPadecimientos = grupo.padecimientos.map(p => p.padecimiento.idPadecimiento);
                    }
                    //si el padecimiento ya existe solo agregamos el diente
                    if(idsPadecimientos.includes(item.p.padecimiento.idPadecimiento)){
                        grupo.padecimientos.forEach(p => {
                            if(p.padecimiento.idPadecimiento == item.p.padecimiento.idPadecimiento){
                                p.dientes.push(item.p.diente)
                                item.p.diente.seleccionado = true;
                                grupo.numOds++;
                            }
                        });
                    }else{
                        //no existe padecimiento, lo agregamos con el diente
                        let dientes = [];
                        dientes.push(item.p.diente);
                        grupo.padecimientos.push({dientes: dientes, padecimiento: item.p.padecimiento})
                        item.p.diente.seleccionado = true;
                        grupo.numOds++;
                    }
                }
            });
            //validar si ya se agregaron todos los dientes de ese padecimiento
            let odSeleccionados = 0;
            item.padecimiento.dientes.forEach(diente => {
                if(diente.diente.seleccionado == true){
                    odSeleccionados++;
                }
            });
            if(item.padecimiento.dientes.length == odSeleccionados){
                item.padecimiento.seleccionado = true;
            }
        },
        
        eliminarDiente(item) {
            //se habilita poder selececcionar el diente otra vez
            this.formularioPadecimientos.forEach(padecimiento => {
                padecimiento.dientes.forEach(diente => {
                    if(diente.diente.idDiente == item.diente.idDiente){
                        diente.diente.seleccionado = false;
                        padecimiento.seleccionado = false;
                    }
                });
            });

            //se quita el diente
            item.dientes.splice(item.indexD,1)
            item.grupo.numOds = item.grupo.numOds - 1;

            //si no hay mas dientes en el padecimiento, se quita el padecimiento
            if(item.dientes.length == 0){
                item.padecimientos.splice(item.indexP,1)
            }
        },

        eliminarPadecimiento(item){
            let numDientesQuitados = 0
            //se habilita poder selececcionar el padecimiento con sus dientes
            this.formularioPadecimientos.forEach(padecimiento => {
                padecimiento.dientes.forEach(diente => {
                    item.padecimientosG.dientes.forEach(d => {
                        if(diente.diente.idDiente == d.idDiente){
                            diente.diente.seleccionado = false;
                            padecimiento.seleccionado = false;
                            numDientesQuitados++;
                        }
                    });
                });
            });

            //quitamos el padecimiento con sus ods
            item.grupos.splice(item.indexP,1)
            item.grupo.numOds = item.grupo.numOds - numDientesQuitados;
            
        },

        agregarTratamiento(grupo) {
            const item = {idTratamiento: null, cantidad: 1, modificado: true, collapseOpen: false}
            grupo.tratamientos.push(JSON.parse(JSON.stringify(item)))
        },
        
        eliminarTratamiento(item) {
            item.grupo.splice(item.grupo.indexOf(item.item), 1)
        },
    }
}
</script>

<style scoped>
.hc p {
    color: #7A7A7A; 
}

.scrollable-container-mult-tx {
    overflow-y: auto;
    max-height: 62vh;
}

.scrollable-container-mult-tx2 {
    overflow-y: auto;
    max-height: 67vh;
}

.barras {
    border-width: 1px;
    border-style: solid;
    border-color: #c2e7ff;
    background: #ffffff;   
    padding-right: 4%;
    padding-left: 1%;
    border-radius: 20px;
    text-align: left;
    align-items: center;
}

.btn-extra-small {
    padding: 0.15rem 0.4rem;
    font-size: 0.7rem;
    line-height: 1.5;
}

.icon-boton {
    margin: auto;
    height: 20px;
    display: block;
    margin-right: 1px;
}
</style>